import React, { useState } from 'react';

function ChatInput({ onSendMessage }) { // Removed setWs prop and reconnectWs prop
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    onSendMessage(message);
    setMessage('');
  };

  return (
    <div className="chat-input flex space-x-2 p-4 bg-gray-100">
      <input
        type="text"
        placeholder="请输入消息..."
        className="flex-1 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
      />
      <button
        className={`font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline bg-blue-500 hover:bg-blue-700 text-white`}
        onClick={handleSendMessage}
      >
        发送
      </button>
    </div>
  );
}

export default ChatInput;
